export const HOME = '/';
export const MELBOURNE = '/melbourne';
export const SYDNEY = '/sydney';

export const citiesRoute = {
  sydney: SYDNEY,
  melbourne: MELBOURNE,
};
